module.exports = __webpack_public_path__ + "img/Bodice-Back-Jb-Kc-Lc.0d4b84ec.png";